import { Inject, Injectable } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';
import { Observable, Subscription } from 'rxjs';
import { Message } from '@stomp/stompjs';
import { HttpClient } from '@angular/common/http';
import { StompConfigurationDto } from './stomp-configuration.dto';
import { stompConfig } from './stomp.config';

@Injectable()
export class StompService extends RxStomp {

	constructor(private http: HttpClient) {
		super();
		this.recupererConfiguration();
	}

	/**
	 * S'abonne à un topîc.
	 * @param topic le nom du topic
	 * @param callbackNotificationRecue callback à appeler à la réception de message sur le topic
	 * @return l'abonnement (utile pour se désabonner)
	 */
	abonnerTopic<T>(topic: string, callbackNotificationRecue: (data: T) => void): Subscription {
		return this.watch(`/topic/${topic}`)
			.subscribe((message: Message) => {
				callbackNotificationRecue(JSON.parse(message.body).data);
			});
	}

	/**
	 * S'abonne à une queue.
	 * @param queue le nom de la queue
	 * @param callbackNotificationRecue callback à appeler à la réception de message sur la queue
	 * @return l'abonnement (utile pour se désabonner)
	 */
	abonnerQueue<T>(queue: string, callbackNotificationRecue: (data: T) => void): Subscription {
		return this.watch(`/queue/${queue}`)
			.subscribe((message: Message) => {
				callbackNotificationRecue(JSON.parse(message.body).data);
			});
	}

	/**
	 * Se désabonne de l'abonnement spécifié ou des abonnements spécifiés.
	 * @param abonnement
	 */
	desabonner(abonnement: Subscription | Array<Subscription>): void {
		if (abonnement) {
			if (abonnement instanceof Array) {
				abonnement.forEach(abonnementInLoop => abonnementInLoop.unsubscribe());
			}
			else {
				abonnement.unsubscribe();
			}
		}
	}

	recupererConfiguration(): void {
		const https = window.location.protocol.toLowerCase().startsWith('https');
		this.http.get<StompConfigurationDto>(`/ws/stomp/configuration?https=${https}`).subscribe(
			(configurationDto: StompConfigurationDto) => {
				this.deactivate().then(_ => {
					const protocole = https ? 'wss' : 'ws';
					stompConfig.brokerURL = `${protocole}://${configurationDto.url}:${configurationDto.port}/ws`;
					stompConfig.connectHeaders['login'] = configurationDto.username;
					stompConfig.connectHeaders['passcode'] = configurationDto.password;
					stompConfig.connectHeaders['host'] = configurationDto.vhost;
					this.configure(stompConfig);
					this.activate();
				});
			},
			error => {
				console.log(`Erreur connexion STOMP : ${error}`);
			}
		);
	}

	desactiver() {
		this.deactivate().then(_ => {
			console.log(`Désactivation de la websocket`);
		});
	}
}
